// Keep colors in sync with _common.scss.
const colors = {
  yellow: '#EBA337',
  lightYellow: '#FFD600',
  red: '#D32E5E',
  purple: '#5F4A8B',
  black: '#222',
  gray: '#777',
  lightestGray: '#f2f2f2',
  white: '#fff',
};

export default colors;
